import { render, staticRenderFns } from "./driverBox.vue?vue&type=template&id=ca65d6fa&scoped=true&"
import script from "./driverBox.vue?vue&type=script&lang=js&"
export * from "./driverBox.vue?vue&type=script&lang=js&"
import style0 from "./driverBox.vue?vue&type=style&index=0&id=ca65d6fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca65d6fa",
  null
  
)

export default component.exports